import { SearchCriteriaListComponent } from './search-criteria-list/search-criteria-list.component';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input, HostBinding, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TREE_ACTIONS, TreeModel, TreeNode, TreeComponent } from '@circlon/angular-tree-component';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { LayerListProviderService } from 'src/app/services/layer-list-provider.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo, SearchParams, CriterionParam, JSONString, SearchHandler, AndOr } from 'src/app/types/@types/sl-v-types';
import { Comparisons, COMPARESTR, COMPARE } from 'src/app/types/@types/comparisons';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { SLMapMemory } from 'src/app/model/sl-map-memory';
import { BufferFormComponent } from '../buffer-form/buffer-form.component';
import { BufferSrc } from 'src/app/model/buffersrc';
import { ResultsService } from 'src/app/services/results.service';
import { CriteriaRegistry, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';
import { Dict } from 'src/app/types/decorable';
import { DragulaService } from 'ng2-dragula';
import { UUID } from 'angular2-uuid';
import { Event } from '@angular/router';


@Component({
  selector: 'app-search-view',
  templateUrl: './search-view.component.html',
  styleUrls: ['./search-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchViewComponent implements OnInit, OnDestroy {
  @ViewChild('tree', { static: true }) tree: TreeComponent;
  @Input() includeHeading: 'on' | 'off' = 'on';
  @Input() includeSearchButton: 'on' | 'off' = 'on';
  @Input() includeLayerSelect: 'on' | 'off' = 'on';
  @Input() includeSearchNav: 'on' | 'off' = 'on';
  @Input() maxCriteria: number = Number.POSITIVE_INFINITY;
  @Input() includeMapLimit: 'on' | 'off' = 'on';
  @Input() panelless: 'on' | 'off' = 'off';

  @Output() resultsReady: EventEmitter<any> = new EventEmitter();
  @Output() viewChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('pane', { static: true }) pane: ElementRef;
  @ViewChild('criteriaList', { static: true }) criteriaList: SearchCriteriaListComponent;
  @HostBinding('class.search-open') searchOpen = false;
  @HostBinding('class.search-closed') searchClosed = true;
  @HostBinding('style.max-height') maxHeight = 'auto';
  @Output() visChange: EventEmitter<any> = new EventEmitter();
  public maxTreeHeight = 'auto';
  public maxHeightPx = 0;
  // tslint:disable-next-line: variable-name
  public _updated = true;
  public map: ISLMap;
  public searchableLayers: Array<SLLayer> = [];
  public selectedLayer: SLLayer = null;
  public searchTip = '';
  public fields: Array<AttributeInfo>;
  public searchTipClosed:boolean = true;
  public hasRemembered = false;
  private subscriptions: SubScriptionMgr = new SubScriptionMgr();
  private id = 1;
  // private inputsReady = false;
  public noLayer = true;
  public isPolygon = false;
  public isMemoryVector = false;
  public memoryType = '';
  public isExpanded = true;
  public maxPanelHeight = 'fit-content';
  public fitHeight = false;
  public search_id = UUID.UUID();
  private criteriaMemory = {}

  private registry: CriteriaRegistry = {};
  nodes: Array<any> = [{
    id: -1,
    name: 'Search',
    layers: [],
    searchTip: '',
    children: [{
      id: 0,
      limitToMapped: false,
      matchMemory: false,
      intersectMode: 0,
      useBuffer: false,
      buffer: 0,
      bufferUnit: 'ft'
    }]
  }];
  public criteria: Array<CriterionParam> = [];
  public treeOptions = {
    allowDrag: false,
    actionMapping: {
      mouse: {
        drop: (tree: TreeModel, node: TreeNode, $event: any, { from, to }) => {
          if (from.parent.data.id !== to.parent.data.id) {
            return;
          }
          let toData = 'end';
          if (to.parent.children.length !== to.index) {
            toData = to.parent.children[to.index].data.id;
          }
          // tslint:disable-next-line: object-literal-key-quotes
          // this.orderChange.emit({ 'fromId': fromId, toId: toData });

          // use from to get the dragged node.
          // use to.parent and to.index to get the drop location
          // use TREE_ACTIONS.MOVE_NODE to invoke the original action
          TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });
          this.Refresh();
        }
      }
    }
  };
  public get hideFooter(): boolean {
    if (this.panelless === 'on') return false;
    if (!this.isExpanded) return true;
    return false;
  }
  public criteriaDragulaBag;
  private _ready = false;
  constructor(
    private layerAPI: LayerApiService,
    private layerListProvider: LayerListProviderService,
    private messager: ModalMessagerService,
    private resultsSvc: ResultsService,
    private cdr: ChangeDetectorRef,
    private dragulaSvc: DragulaService,
    private domNode: ElementRef) {

  }

  private dragulaSubscription;
  ngOnInit() {
    this._ready = true;
    this.criteriaDragulaBag = this.dragulaSvc.createGroup('CRITERIA_BAG-' + this.search_id, {
      moves: (el?: Element, container?: Element, handle?: Element) => {
        return handle?.classList.contains('grip') === true;
      }
    })
    this.dragulaSubscription = this.dragulaSvc.drag('CRITERIA_BAG-' + this.search_id)
      .subscribe(({ name, el, source }) => {
        (el as HTMLElement).style.cursor = 'grabbing'

        setTimeout(() => {
          const mirror = document.querySelector('.gu-mirror');
          if (mirror) {
            mirror.classList.add('criterion-drag-item');
          }
        }, 0);
      });
    this.dragulaSubscription = this.dragulaSvc.dragend('CRITERIA_BAG-' + this.search_id)
      .subscribe(({ name, el }) => {
        (el as HTMLElement).style.cursor = ''
      })
    // this.ToggleTreeVis(true);
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) {
      this.cdr.detectChanges();
    }
  }
  /* HandleRegistrant(registrant: SearchCriteriaRegistrant, id: number) {
    this.registry[id] = registrant.component;
  }*/
  CanHideHeading(nodeData: any) {
    if (this.includeHeading === 'off') {
      return true;
    }
    if (nodeData.id !== -1) {
      return true;
    }

  }
  NoMoreAllowed(count: number) {
    return (count >= this.maxCriteria);
  }

  SetMap(map: ISLMap) {
    this.map = map;
    /*for (const layer of this.layerListProvider.GetSearchableLayers(this.map.layers, false)) {
      this.searchableLayers.push(layer);
    }*/
    this.UpdateSearchables();
    // this.Refresh();
    this.subscriptions.Subscribe(this.map.memory.changes, (e) => {
      e = null;
      this.hasRemembered = this.map.memory.featureCount > 0;
      if (this.hasRemembered) {
        if (!!this.map.memory.layer.typeString) {
          this.isMemoryVector = this.map.memory.layer.typeString === 'vector';
          this.memoryType = this.map.memory.layer.geom;
        } else {
          this.isMemoryVector = false;
          this.memoryType = '';
        }
      } else {
        this.isMemoryVector = false;
        this.memoryType = '';
      }
      const mainNode: any = this.nodes[0].children[0];
      if (!this.hasRemembered) {
        mainNode.matchMemory = false;
      }
      this.Refresh();

    });
    this.noLayer = true;
    this.Update();
    this.tree.treeModel.expandAll();
    if (this.searchableLayers.length > 0) {
      this.SelectLayer(this.searchableLayers[0]);
    }
    this.Refresh();

  }
  AttSelected(data: any, fieldName: string) {
    this.UpdateOperators(data, fieldName);
    if (data.info.requires === 'date') {
      data.operator = data.operators[COMPARESTR.EQUALS];
    }
    this.Refresh();
  }
  HandleViewChange(node: TreeNode = null, event: any = null) {
    event?.preventDefault();
    event?.stopImmediatePropagation();
    if (node !== null) {
      if (node.id === -1) {
        this.isExpanded = (this.panelless === 'on') ? true : node.isExpanded;
      }
    }
    this.viewChange.emit({ view: this });
    setTimeout(() => { this.viewChange.emit({ view: this }); this.Refresh() }, 250);
    this.Refresh();

  }
  HandleToggle() {
    this.RefreshLayerDisplayHeight();
  }
  ToggleTreeVis(onOrOff: boolean | null = null) {
    this.searchOpen = (onOrOff === null) ? !this.searchOpen : onOrOff;
    this.searchClosed = !this.searchOpen;
    this.SetHeight();
    this.visChange.emit({ id: -1, isOn: this.searchOpen });
    setTimeout(() => {
      if (this.searchOpen === true) {
        this.tree.treeModel.getNodeById(-1).expand();

      } else {
        this.tree.treeModel.getNodeById(-1).collapse();
      }

      this.Refresh();
    }, 250);
    this.isExpanded = (this.panelless === 'on') ? true : this.searchOpen;
    this.Refresh();

  }
  SelectLayer(layer: SLLayer) {
    if (!!this.selectedLayer) {
      this.criteriaMemory[this.selectedLayer.identifier] = JSON.stringify(this.criteria)
    }
    this.DeleteAll();
    this.selectedLayer = layer;

    this.Refresh();
    this.LayerSelected();
    if(this.searchTipClosed == true) {
      this.searchTipClosed = false;
      this.Refresh();
      this.SetHeight();
    }
  }
  RefreshLayerDisplayHeight() {
    const height = this.domNode.nativeElement.getElementsByClassName('general-params')[0]?.clientHeight
    this.domNode.nativeElement.style.setProperty('--layer-display-height', height + 'px');
  }
  LayerSelected(event?) {
    this.registry = {};
    this.fields = this.layerListProvider.GetSearchableFields(this.selectedLayer);
    this.noLayer = false;
    this.searchTip = !!this.selectedLayer.searchTip ? this.selectedLayer.searchTip : '';
    this.RefreshLayerDisplayHeight();
    const criterion = !!this.selectedLayer.defaultCriteria ? this.selectedLayer.defaultCriteria : [];
    if (!!this.criteriaMemory[this.selectedLayer.identifier]) {
      this.criteria = JSON.parse(this.criteriaMemory[this.selectedLayer.identifier]);
    } else {
      if (criterion.length > 0 && this.criteria.length === 0) {
        setTimeout(() => {
          this.AddCriteria({ andor: 'and', 'compare': criterion[1], field: criterion[0], value: criterion.length === 3 ? criterion[2] : '' })
        })
      }
    }
    /*if (criteria.length > 0 && (this.criteria.length === 0)) {
      this.AddCriteria({
        id: this.id + 1,
        andor: 'and',
        compare: criteria[1],
        field: criteria[0],
        value: (criteria.length === 3) ? criteria[2] : ''
      });
    }*/

    this.tree.treeModel.update();
    this.HandleViewChange();
    this.cdr.markForCheck();
    this.Refresh();
    this.RefreshLayerDisplayHeight();

  }
  DeleteAll() {
    this.id = 1;
    this.criteria = [];
    this.HandleViewChange();
    this.registry = {};
    this.Refresh();
  }
  Delete(criterion: CriterionParam) {
    if (this.registry.hasOwnProperty(criterion.id)) {
      delete this.registry[criterion.id];
    }
    this.HandleViewChange();
    this.Refresh();
  }
  AddCriteria(newCriterion?: CriterionParam) {
    const criteria = this.criteriaList.AddCriteria(newCriterion);
    this.Refresh();
    this.UpdateHeight('', this.maxHeight)

    // this.inputsReady = false;

    if (this.registry.hasOwnProperty(criteria.id)) {
      delete this.registry[criteria.id];
    }

    const criterion: any = !!newCriterion ? newCriterion : {
      id: this.id,
      andor: 'and',
      operator: COMPARESTR.HAS,
      field: this.fields[0].name,
      val: ''
    };
    criterion.id = this.id;
    this.UpdateOperators(criterion, criterion.field);
    this.criteria.push(criterion);
    // this.inputsReady = true;
    this.HandleViewChange();
    this.cdr.markForCheck();
    this.Refresh();
  }
  NameToField(fieldName: string): AttributeInfo {
    for (const field of this.fields) {
      if (field.name === fieldName) {
        return field;
      }
    }
  }
  UpdateOperators(data: CriterionParam, field: string) {

    data.field = field;
    const info = this.NameToField(field);
    data.info = info;
    switch (info.requires) {
      case 'numeric':
      case 'float':
      case 'int':
      case 'integer':
      case 'time':
        data.operators = Comparisons.GetNumeric();
        data.inputType = 'numeric';
        if (info.requires === 'time') {
          data.inputType = 'time';
        }
        break;
      case 'memory':
        data.operators = Comparisons.GetMemory();
        data.inputType = 'memory';
        break;
      case 'text':
      case 'string':
      case 'cg_url':
      case 'url':
      case 'date':
        data.operators = Comparisons.GetString();
        data.inputType = 'text';
        if (info.requires === 'date') {
          data.operators = Comparisons.GetDate();
          if (data.compare === COMPARESTR.HAS) {
            data.compare = data.operators[COMPARESTR.EQUALS];
            data.inputType = 'date-value';
            this.CompareChanged({ data: (data) });
          }
        }
        break;
      case 'boolean':
        data.operators = Comparisons.GetBoolean();
        data.inputType = 'checkbox';
        break;
    }
    this.Refresh();
  }
  CompareChanged(node: any, notify: boolean = true) {
    switch (node.data.operator) {
      case COMPARE.DATE_EQUALS:
      case COMPARE.DATE_AFTER:
      case COMPARE.DATE_BEFORE:
        node.data.inputType = 'date-value';
        break;

      case COMPARE.DATE_BETWEEN:
      case COMPARE.DATE_NOT_BETWEEN:
        node.data.inputType = 'date-buffer';
        break;

      case COMPARE.DATE_IS_A:
      case COMPARE.DATE_IS_NOT_A:
        node.data.inputType = 'date-kind';
        break;
      case COMPARE.DATE_IS_ONE_OF:
      case COMPARE.DATE_IS_NOT_ONE_OF:
        node.data.inputType = 'date-kinds'
        break;
    }
    this.Refresh();

  }
  ValChanged() {
    // this.valChange.emit(this.val);
    this.Refresh();
  }
  HandleCriterionValue(criterion: CriterionParam, val: any) {
    criterion.value = val;
  }
  Update() {
    this._updated = false;
    this.Refresh();
    // this.inputsReady = false;
    //setTimeout(() => {
    this._updated = true;
    // this.inputsReady = true;
    this.Refresh();
    //}, 120);
  }
  GetCriteria(): Array<CriterionParam> {
    const filters = this.Search(true).filters;
    return filters ? JSON.parse(filters) : [];
  }
  Search(buildParamsOnly = false, handler: SearchHandler = null): void | any {
    if (buildParamsOnly === false) {
      this.messager.Progress('Preparing search', true, .33, 'Searching for features ...');
    }
    const params: SearchParams = {
      idField: 'gid',
      /* fields: this.selectedLayer.layerAttributes
          .filter((attribute) => AttributesService.IsVisible(attribute))
          .map((attribute) => attribute.name)
          .join(','), */
    };
    if (this.selectedLayer.isPLayer) {
      params.player = this.selectedLayer.identifier;
    } else {
      params.layer = this.selectedLayer.id;
    }
    const mainNode: any = this.nodes[0].children[0];
    if (mainNode.intersectMode === undefined) {
      mainNode.intersectMode = 0;
    }
    const filters: Array<CriterionParam> = [];
    let isFirst = true;
    let i = 0;
    for (const c of this.criteriaList.criteria) {
      const criterion = this.NodeToCriterion(c);
      if (criterion !== null) {
        if (i === 0) {
          criterion.group_start = '(';
        }
        filters.push(criterion);
      }
      i++;
    }
    if (filters.length > 0) {
      filters[filters.length - 1].group_end = ')';
      params.filters = JSON.stringify(filters) as JSONString;
    }
    if (mainNode.limitToMapped === true) {
      params.bbox = this.map.MapExtentToBBox(this.map.ui.getBounds());
    }
    if (mainNode.matchMemory === true) {
      if (!!this.map.memory) {
        params.intersectMode = mainNode.intersectMode;
        params.memoryLayer = this.map.memory.layer.id;
        params.gids = this.map.memory.features.join(',');
      }
    }
    let bufferSrc: BufferSrc = null;
    if (mainNode.useBuffer) {
      if (mainNode.buffer !== '') {
        const buffer = parseFloat(mainNode.buffer);
        bufferSrc = new BufferSrc(buffer, mainNode.bufferUnit);
        params.buffer = bufferSrc.value;
      }
    }

    if (buildParamsOnly === true) {
      return params;
    }
    this.messager.Progress('Submitting search', false, .66, 'Searching for features ...');
    setTimeout(() => {
      this.layerAPI.SearchFeatures(params).then((response) => {
        if (response === undefined) {
          this.messager.Progress('No results', false, 1, 'Searching for features ...');
          return;
        }
        this.messager.CancelProgress('Searching for features ...');
        this.resultsReady.emit(response.results);
        // ResultService
        // SetResultSet()
        // ResultSet: {src: 'search',params:...,bufferSrc:...,reults:results}

        this.resultsSvc.SetTabularResults(response, 'search', params, 'features/search', bufferSrc, true);

        // this.resultsSvc.SelectAll();
        if (!!handler) {
          handler(this.resultsSvc);
        }

      }).catch((reason: any) => {
        reason = reason;
        this.messager.CancelProgress('Searching for features ...');
        this.messager.Notify('There was an unknown problem performing the requested search', true, 'Problem retrieving features');
        console.log('Search Problem', reason);
      });
    }, 50);
  }
  private _panelHeight;
  UpdateHeight(_myPanel: any, maxHeight: number | string) {
    const changed = this._panelHeight === maxHeight;
    this.maxHeight = 'calc(' + maxHeight + 'px - var(--gutters-bottom-thickness,0px)))';
    this.maxTreeHeight = 'calc(' + maxHeight + 'px - 4em';
    this.maxPanelHeight = 'calc(' + maxHeight + 'px - 1em)';
    this.SetHeight();
    this.cdr.markForCheck();
    this.Refresh();
    return changed;
  }
  private SetHeight() {
    this.RefreshLayerDisplayHeight();

    // this.fitHeight = this.searchOpen;
    this.isExpanded = (this.panelless === 'on') ? true : this.searchOpen;
    // this.domNode.nativeElement.style.height = this.layersOpen ? 'fit-content' : '2.5em';
    this.Refresh();

  }
  NodeToCriterion(criterionParam: CriterionParam): CriterionParam | null {
    if (!(!!criterionParam.id)) return null;
    if (!(!!criterionParam.field)) {
      return null;
    }
    if (!criterionParam.id) {
      return null;
    }

    // const criterionComponent = this.registry[node.id];
    // const criterion: CriterionParam = criterionComponent.ToCriterion(node.field, node.operator) as CriterionParam;
    const isDate = criterionParam.compare?.indexOf('date-') === 0;
    const criterion: CriterionParam = { field: criterionParam.field, compare: criterionParam.compare, value: criterionParam.value }
    if (isDate) {
      criterion.casting = 'date';
    }
    if (!!criterionParam.andor) {
      criterion.andor = criterionParam.andor;
    }

    if (!!criterionParam.group) {
      criterion.group = criterionParam.group;
    }
    if (!!criterionParam.modifier) {
      criterion.modifier = criterionParam.modifier;
    }
    return criterion;
  }
  UpdateIntersectMode(e: any) {
    const mainNode: any = this.nodes[0].children[0];
    mainNode.intersectMode = e.currentTarget.value;
    this.HandleViewChange();
    this.Refresh();
  }
  GoToLayer() {
    this.map.GoToLayer(this.selectedLayer);
  }
  private _autoZoom = false;
  private _autoSearch = false;
  AutoSearch(params: any, criterion) {
    if (this._autoSearch === true) return;
    this._autoSearch = true;
    /*if (!!criterion && !this.registry.hasOwnProperty(criterion.id)) {
      window.requestAnimationFrame(() => {
        this.AutoSearch(params, criterion);
      })
      return;
    }*/
    if (!!params.auto) {
      if (params.auto === '1') {
        if (!!params.zoom) { this.map.autoZoom = true; }
        this.Search(false, (results) => {
          if (!!params.query) {

            const features = results.GetGids(this.selectedLayer.id, this.selectedLayer.plid);

            if (features.length > 0) {
              (this.map.memory as SLMapMemory).MemoryAdd(this.selectedLayer, features);
            }
            if (params.query === 'auto') {
              const toolAction: any = { action: 'info/memory-query' };

              if (!!params.buffer) {
                const bufferForm: BufferFormComponent = (this.map.src.bufferForm as BufferFormComponent);
                if (typeof params.buffer === 'string') {
                  bufferForm.SetBufferValue(params.buffer, 'm')
                } else {
                  bufferForm.SetBufferValue(params.buffer[0], params.buffer[1]);
                }
                // bufferForm.UpdateBuffer();
                toolAction.buffer = bufferForm.GetBufferSrc();

              }
              if (!!params.zoom) {
                if (params.zoom === '1') {
                  if (!this._autoZoom) {
                    toolAction.zoom = true;
                  }
                  this._autoZoom = false;
                }
              }
              toolAction.autoSend = true;
              this.map.component.HandleToolAction(
                toolAction
              );
            } else if (params.query === 'autosingle') {
              if (!!params.qlayer) {
                let qLayer = null;
                for (const layer of this.searchableLayers) {
                  if (layer.id === params.qlayer) {
                    qLayer = layer;
                  }
                }

                if (qLayer !== null) {
                  this.SelectLayer(qLayer);
                  this.DeleteAll();
                  const mainNode: any = this.nodes[0].children[0];
                  mainNode.matchMemory = true;
                  mainNode.intersectMode = 1;
                  if (!!params.buffer) {
                    mainNode.buffer = params.buffer;
                    mainNode.bufferUnit = 'm';
                    mainNode.useBuffer = true;

                  }
                  this.map.autoZoom = true;
                  this.Search(false, () => {
                    setTimeout(() => {

                      this.map.autoZoom = false;
                    }, 5000);
                  });

                }
              }
            }
          } else {
            this.map.autoZoom = false;
          }

        });
      }
    }

  }
  HandleExtras(params: any) {
    if (!!params.hasOwnProperty('ppanelExpanded')) {
      if (params.ppanel?.panel === 'search') {
        params.ppanelExpanded = !!params.search;
      }
    }
    this.ToggleTreeVis(params.ppanelExpanded);
    if (!!params.search) {
      for (const layer of this.searchableLayers) {
        if (layer.identifier === params.search) {
          this.SelectLayer(layer);
          break;
        }
      }
      setTimeout(() => {
        let criterion: any;
        if (!!params.criteria) {
          this.DeleteAll();
          /*let criteriaEncoded = decodeURIComponent(params.criteria);
          if (decodeURIComponent(criteriaEncoded) !== criteriaEncoded) {
            criteriaEncoded = decodeURIComponent(criteriaEncoded);
          }*/
          const searchCriteria = (typeof params.criteria === 'string') ? params.criteria.split(';') : params.criteria.join(',').splt(';')
          for (const searchC of searchCriteria) {
            const criteria = searchC.split(':')

            let field = '';
            let operator = '';
            let val = '';
            let andor = 'and';
            if (criteria.length == 4) {
              [andor, field, operator, val] = criteria;
            } else if (criteria.length > 2) {
              [field, operator, val] = criteria;
            } else {
              [field, operator] = criteria;
            }
            criterion = { andor: andor, field: (field), compare: (Comparisons.GetCompareKey(operator.toUpperCase())), value: (val) };
            setTimeout(() => {
              this.AddCriteria(criterion as CriterionParam);
            }, 0)
          }
        }
        setTimeout(() => {
          this.AutoSearch(params, criterion);
        }, 1)
      }, 0)


    }
  }
  Expand(isExpanded: boolean = true) {
    this.isExpanded = isExpanded;
    if (this.isExpanded === true) {
      this.tree.treeModel.expandAll();
    } else {
      this.tree.treeModel.collapseAll();
    }
    this.searchOpen = this.isExpanded;
    this.Refresh();
    this.SetHeight();
    //this.Refresh();

  }
  ToggleExpanded(expanded?: boolean) {
    if (expanded === undefined) expanded = !this.isExpanded;
    this.Expand(expanded);
  }
  IsSingleDate(node: any) {
    if (!node.date) return false;
    return ['date-value', 'date-before', 'date-after'].indexOf(node.date.inputType) > -1;
  }
  UpdateSearchables() {
    this.searchableLayers = [];
    this.Refresh();
    for (const layer of this.layerListProvider.GetSearchableLayers(this.map.layers)) {
      this.searchableLayers.push(layer);

    }
    this.searchableLayers = this.layerListProvider.GetSortedUniqueLayers(this.searchableLayers);
    this.Refresh();

  }
  ngOnDestroy(): void {
    this.dragulaSvc.destroy('CRITERIA_BAG-' + this.search_id)
    if (this.dragulaSubscription) {
      this.dragulaSubscription.unsubscribe();
    }
  }
  ToggleSearchTip() {
    this.searchTipClosed = !this.searchTipClosed;
    this.Refresh();
    this.SetHeight();
  }
}

